<template>
    <div data-testid="count-actions__toolbar" class="d-flex gap-1 text-right">
        <v-tooltip bottom content-class="tooltip-bottom" v-if="showBulkUpload">
            <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on"
                    @click.stop="$emit('bulk-upload')">
                    <img src="/img/icons/BulkRUUpload.svg" alt="Bulk RU level upload Icon" />
                </v-btn>
            </template>
            <span class="noTransform">{{ bulkUploadTooltip }}</span>
        </v-tooltip>
        <v-tooltip left content-class="tooltip-left">
            <template v-slot:activator="{ on, attrs }">
                <v-btn data-testid="count-actions__pending-approval-button" class="" icon v-bind="attrs" v-on="on"
                    @click.stop="handlePendingRequests">
                    <img src="/img/icons/PendingApprovalIcon.svg" alt="Pending Approval Icon" />
                </v-btn>
            </template>
            <span>View pending approval ({{ pendingRequestCount }})</span>
        </v-tooltip>

        <v-tooltip bottom content-class='tooltip-bottom'>
            <template v-slot:activator="{ on, attrs }">
                <v-btn data-testid="count-actions__faq-button" v-bind="attrs" v-on="on" name="faq"
                    @click="handleShowFAQ" icon>
                    <img src="/img/icons/FaqIcon.svg" alt="FAQ Icon" />
                </v-btn>
            </template>
            <span class="noTransform">FAQ</span>
        </v-tooltip>

        <!-- Column Selection Menu -->
        <v-menu 
            v-if="headers.length > 0"
            data-testid="count-toolbar__columns-menu" 
            offset-y 
            transition="slide-y-transition" 
            :close-on-content-click="false" 
            scrollable 
            max-height="250"
            max-width="300"
        >
            <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip data-testid="count-toolbar__columns-tooltip" left content-class="tooltip-left">
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn 
                            data-testid="count-toolbar__columns-btn" 
                            icon  
                            class="" 
                            v-bind="attrs" 
                            v-on="{ ...tooltip, ...menu }"
                        >
                            <img data-testid="count-toolbar__columns-icon" src="/img/icons/MenuIcon.svg" alt="Select Columns" />
                        </v-btn>
                    </template>
                    <span>Select Columns</span>
                </v-tooltip>
            </template>
            <div class="pa-3 white" style="max-height: 250px; min-width: 150px; overflow-y: auto;" data-testid="count-toolbar__columns-list">
                <div class="">
                    <v-checkbox 
                        data-testid="count-toolbar__column-checkbox"
                        v-for="(option, index) in selectableHeaders" 
                        :key="index" 
                        class="" 
                        dense 
                        scrollable
                        :input-value="selectedColumns.includes(option.value)"
                        hide-details 
                        @change="toggleColumn(option.value)"
                    >
                        <template v-slot:label>
                            <span>{{ option.text }}</span>
                        </template>
                    </v-checkbox>
                </div>
            </div>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'CountToolbar',
    props: {
        pendingRequestCount: {
            type: Number,
            default: 0
        },
        pendingRequestLoading: {
            type: Boolean,
            default: false
        },
        showBulkUpload: {
            type: Boolean,
            default: false
        },
        bulkUploadTooltip: {
            type: String,
            default: 'Bulk RU level upload'
        },
        headers: {
            type: Array,
            default: () => []
        },
        visibleColumns: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectedColumns: []
        };
    },
    computed: {
        selectableHeaders() {
            return this.headers.filter((header) => {
                return header.lock !== undefined && !header.lock;
            });
        }
    },
    watch: {
        visibleColumns: {
            immediate: true,
            handler(newVal) {
                this.selectedColumns = [...newVal];
            }
        }
    },
    methods: {
        handlePendingRequests() {
            this.$emit('get-pending-requests');
        },
        handleShowFAQ() {
            this.$emit('show-faq');
        },
        handleRefresh() {
            this.$emit('refresh');
        },
        toggleColumn(columnValue) {
            const index = this.selectedColumns.indexOf(columnValue);
            if (index > -1) {
                this.selectedColumns.splice(index, 1);
            } else {
                this.selectedColumns.push(columnValue);
            }
            this.$emit('update:visibleColumns', [...this.selectedColumns]);
        }
    }
}
</script>

<style scoped></style>
